import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function isDatetimeValid
     * @function cleanTimeFormDatetime
     * @function getEndOfMonth
     ****************************/
    convertDateToTimeStampUnix: function(date) {
        var unixTime = (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000;
        return unixTime;
    },
    convertTimestampToDate: function (timestamp) {
        var dateFormat = Moment.unix(timestamp).format('YYYY-MM-DD');
        return new Date(dateFormat);
    },
    /**
     * @param {number|string} y - A.D. year only, ปี ค.ศ. เท่านั้น (Thai year need to convert before check.)
     * @param {number|string} m - (1 - 12)
     * @param {number|string} d - (1 - 31)
     */
    isDatetimeValid: function(y, m, d) {
        var year = y;
        var month = m < 10 ? '0' + m : m;
        var day = d < 10 ? '0' + d : d;
        var dateFormat = year + '-' + month + '-' + day;

        return Moment(dateFormat).isValid();
    },
    cleanTimeFormDatetime: function(datetime) {
        var date = new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
        return date;
    },
    getEndOfMonth: function(year, month) {
        month = parseInt(month) < 10 ? '0' + month : month;
        var yearMonth = `${year}-${month}-01`;
        var lastDayStr = Moment(yearMonth, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
        return new Date(lastDayStr);
    },

    /********** Date Format ***********
     * @function dateFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/
    dateFullFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            Moment.locale('en');
        } else {
            Moment.locale('th');
        }
        var date = Moment.unix(timestamp).utc().format('DD MMMM ');
        var year = Moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);

        return `${date}${year}`;
    },
    dateFullFormatNoUtc: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            Moment.locale('en');
        } else {
            Moment.locale('th');
        }

        var date = Moment.unix(timestamp).format('DD MMMM ');
        var year = Moment.unix(timestamp).format('YYYY');
        year = this.getYearByLocale(year);

        return `${date}${year}`;
    },
    getDatetimeFullFormat: function (timestamp) {
        var date = this.dateFullFormat(timestamp);
        var time = Moment.unix(timestamp).utc().format(' - HH:mm')
        return `${date}${time}`
    },
    getEarnDatetimeFullFormat: function (timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            Moment.locale('en');
        } else {
            Moment.locale('th');
        }

        var date = Moment.unix(timestamp).format('DD/MM/');
        var year = Moment.unix(timestamp).format('YYYY');
        year = this.getYearByLocale(year);
        year = year.toString().substring(2, 4);

        var time = Moment.unix(timestamp).format(' HH:mm');
        if (Locale.getLocaleCode() == 1054) {
            time = `${time}น.`;
        }

        return `${date}${year}${time}`;
    },
    getDatetimeFullFormatNoUtc: function (timestamp) {
        var date = this.dateFullFormatNoUtc(timestamp);
        var time = Moment.unix(timestamp).format(' - HH:mm')
        return `${date}${time}`
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function(timestamp) {
        var date = Moment.unix(timestamp).utc().format('HH:mm:ss');
        return date;
    },
    dateShortFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            Moment.locale('en');
        } else {
            Moment.locale('th');
        }
        var date = Moment.unix(timestamp).utc().format('DD/MM');
        var year = Moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);
        year = year.toString().substring(2, 4);

        return `${date}/${year}`;
    },
}
